import { Component, Vue } from 'vue-property-decorator'
import { IUsersServices } from '@/types';
import Multiselect from 'vue-multiselect'
import addCertificate from '../add-google-certificate/add-google-certificate.vue'
import { validEmail, validDomain, isBetween, isGreaterThan } from '../../../helper-functions/validators'
import textInput from '../../../components/text-input/text-input.vue'

const initialState = {
  tempEmail: '',
  domain: '',
  analyticViewId: '',
  serpbookCatName: ''
} as Partial<AddService>;

@Component({
  components: {
    Multiselect,
    addCertificate,
    textInput
  }
})

export default class AddService extends Vue {

  private namespace: string = '/Console';

  private clientEmailsAndIds: {clientEmail: string, clientId: string}[] | null = null;

  private existingUser: boolean = false;

  private hasAnalytics: boolean = false;

  private hasSerpbook: boolean = false;

  private tempEmail: string = '';

  private domain: string = '';

  private analyticViewId: string = '';

  private serpbookCatName: string = '';

  private alertMessage: string = '';

  private service: {label: string, userId: string} | null = null;

  private analyticClientId: {label: string, clientId: string} | null = null;

  private reportRecievers: {
    reportReceiverId: number,
    reportReceiverEmail: string
  }[] | null = null;

  private reportReciever: {
    reportReceiverId: number,
    reportReceiverEmail: string
  }[] | null = null;

  private modalOpen: boolean = false;

  private error: boolean = false;

  private disabled: boolean = false;

  private get Services () {
			
		return this.$store.state.session.services.map((service: IUsersServices) => (

			{label: service.displayName, userId: service.userId}
		));
  }

  private get ClientIds (): {label: string, clientId: string}[] {

    if (this.clientEmailsAndIds != null) {
      return this.clientEmailsAndIds.map((client: {clientEmail: string, clientId: string}) => {

        return {label: client.clientEmail, clientId: client.clientId};
      });
    }

    return [{label: this.$tc('shared.notSet', 1), clientId: ''}];
  }

  private get ValidEmail () {

    return validEmail(this.tempEmail);
  }

  private get ValidDomain () {

    return validDomain(this.domain);
  }

  private get ValidAnalyticViewId () {

    return isBetween(5, 15, this.analyticViewId);
  }

  private get ValidserpbookCatName () {

    return isGreaterThan(0, this.serpbookCatName);
  }

  private get enabled () {

    const domain = this.ValidDomain;

    const userProvided = this.existingUser ? this.service != null : this.ValidEmail;

    const analytics = !this.hasAnalytics || (this.analyticClientId != null && this.ValidAnalyticViewId);

    const serpbook = !this.hasSerpbook || this.ValidserpbookCatName;

    const hasAnyData = this.hasAnalytics || this.hasSerpbook;  // TODO: Check with Shayan

    return domain && userProvided && analytics && serpbook && hasAnyData && this.reportReciever != null;
  }
  
  beforeMount () {

    this.getClientEmailsAndIds();
    this.getReportRecievers();
  }

  private async getClientEmailsAndIds () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/ClientCertificates`);

      this.clientEmailsAndIds = response.data;
    } catch (err) {

      console.error(err);
    }
  }

  private async getReportRecievers () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/ReportReceivers`);

      this.reportRecievers = response.data;
    } catch (err) {

      console.error(err);
    }
  }

  private clearForm (init?: Partial<AddService>) {

    Object.assign(this, {...init});
  }

  private alertReset () {

    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async addService () {
    
    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/AddService`, {
        Domain: this.domain,
        GoogleAnalyticClientId: this.analyticClientId ? this.analyticClientId.clientId : null,
        GoogleAnalyticViewId: this.analyticViewId,
        SerpBookCategoryName: this.serpbookCatName,
        TempEmail: this.tempEmail,
        UserId: this.service != null ? this.service.userId : null,
        ReportReceivers: this.reportReciever != null ? this.reportReciever.map(reciever => reciever.reportReceiverEmail) : []
      });

      this.alertMessage = 'Domain successfuly added.';
      this.clearForm(initialState);
      this.alertReset();
    } catch (err) {
      
      this.error = !this.error;
      this.alertMessage = 'Something went wrong...';
      this.alertReset();
    }
  }

  private modalToggle () {

    this.modalOpen = !this.modalOpen;
    this.$forceUpdate;
  }
}